import { useTranslation } from 'react-i18next'
import { Link } from 'react-router'


import { calculateItemTotal } from '@entities/Product/helpers'

import { useAuth } from '@features/auth'
import { useCartStore } from '@features/cart/model/useCartStore'
import ControlCart from '@features/cart/ui/control'
import DeleteProduct from '@features/cart/ui/delete-product'
import { useErrorInfoModal } from '@features/modal'

import useProductsSimilarModal from '@widgets/products-similar/hooks/useProductsSimilarModal'



import { Product, useDropCartItemMutation } from '@shared/generated'
import { cn } from '@shared/lib/cn'
import { formatPrice } from '@shared/uttils'

import styles from './styles.module.scss'




interface CartListPreviewProps {
  data: Product[];
}

export default function CartListPreview (props: CartListPreviewProps) {
  const { t: te } = useTranslation('errors')
  const { data } = props
  const { getProduct, removeProduct } = useCartStore()
  const { isAuthorized } = useAuth()
  const { openProductsSimilarModal } = useProductsSimilarModal()
  const [ fetchRemoveProduct ] = useDropCartItemMutation()
  const { currentShopId } = useCartStore()
  const { openErrorInfoModal } = useErrorInfoModal()

  const handleRemove = async (productId: string) => {
    if (isAuthorized) {
      try {
        await fetchRemoveProduct({
          variables: {
            shopId: currentShopId as string,
            productId: productId,
          },
        })

        removeProduct(productId)
      }
      catch (error) {
        console.error('fetchRemoveProduct error: ', error)
        openErrorInfoModal({
          description: te('drop_cart_item'),
        })
      }
    }
    else {
      removeProduct(productId)
    }
  }

  return (
    <div className={styles.list}>
      {data.map((item) => {
        const cartItem = getProduct(item.id)
        const OUT_STOCK = !cartItem?.amount

        const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
          if (OUT_STOCK) {
            e.preventDefault()
            openProductsSimilarModal(item.id)
          }
        }

        return (
          <div
            className={cn(styles['preview-cart-item'], {
              [styles.out]: OUT_STOCK,
            })}
            key={item.id}
          >
            <Link
              className={styles['preview-cart-item__image']}
              onClick={handleClick}
              to={`/product/${item.slug}`}
            >
              <img
                src={item.preview?.url || '/icons/flower-grey.svg'}
                onError={(e) => {
                  const target = e.currentTarget
                  if (
                    target.src !==
                    window.location.origin + '/icons/flower-grey.svg'
                  ) {
                    target.src = '/icons/flower-grey.svg'
                  }
                }}
                alt=""
              />
            </Link>

            <div className={styles['preview-cart-item__content']}>
              <Link
                className={styles['preview-cart-item__title']}
                to={`/product/${item.slug}`}
                onClick={handleClick}
              >
                {item.name}
              </Link>

              <div className={styles['preview-cart-item__bottom']}>
                {!OUT_STOCK && (
                  <>
                    <ControlCart isTablet={true} size="small" product={item} />

                    <div className={styles['preview-cart-item__price']}>
                      {item.priceOffer?.price && (
                        <span
                          className={cn(
                            styles['preview-cart-item__price-value'],
                          )}
                        >
                          {formatPrice(calculateItemTotal(item.priceOffer.price as number, cartItem.amount, item.priceOffer?.count_multiplier as number))}
                        </span>
                      )}

                      {!!item.priceOffer?.oldPrice && (
                        <span
                          className={styles['preview-cart-item__price-old']}
                        >
                          {formatPrice(calculateItemTotal(item.priceOffer?.oldPrice as number, cartItem.amount, item.priceOffer?.count_multiplier as number))}
                        </span>
                      )}
                    </div>
                  </>
                )}

                {OUT_STOCK && (
                  <DeleteProduct
                    className={styles['preview-cart-item__delete']}
                    onClick={() => handleRemove(item.id)}
                  />
                )}
              </div>
            </div>
          </div>
        )
      })}
    </div>
  )
}
